/**
 * File: apps/qbench-cp/reactapp/src/shared/layout/MainWrapper.js
 *
 * Purpose: Provides the full-viewport-height flex column wrapper used as the top-level page
 *     shell for the customer portal.
 *
 * Scope: Shared layout primitives for the customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Defines a single styled-components div that fills the viewport height, lays out
 *     its children in a vertical flex column, and applies theme text/background colors. On
 *     desktop and tablet breakpoints it centers items horizontally; on narrower/mobile
 *     viewports items stretch to fill the width.
 *
 * Exports: MainWrapper styled component (default export).
 */

import styled from "styled-components";

const MainWrapper = styled.div`
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	color: ${props => props.theme.color.palette.text.main};
	background-color: ${({ theme }) =>
		theme.color.palette.background.paper.pagebg};
	@media ${({ theme }) => theme.device.desktop} {
		align-items: center;
	}
	@media ${({ theme }) => theme.device.tablet} {
		align-items: center;
	}
`;

export default MainWrapper;
